import MarkdownIt from 'markdown-it'

export default class MarkdownService {
    markdown

    constructor() {
        this.markdown = new MarkdownIt()
    }

    convert(text) {
        // ignore undefined translations
        return text ? this.markdown.renderInline(text) : text
    }
}
